import type { Menu } from '@/menus/types.ts';
export default [
  {
    code: 'CONTACTS',
    icon: 'menu-contacts',
    label: '通讯录',
    placement: 'bottom',
    path: '/contacts',
    public: true,
  },
] satisfies Menu[];
